import React from 'react';
import { resolveHost } from 'common/helpers/resolveHost';
import styles from './ContentLoader.module.scss';

const captionTranslations = new Map()
  .set('en', 'Please wait')
  .set('fr', "S'il vous plaît, attendez")
  .set('de', 'Bitte warten')
  .set('es', 'Espere por favor')
  .set('pl', 'Proszę czekać')
  .set('it', 'Attendere prego')
  .set('gr', 'Παρακαλώ περιμένετε')
  .set('nl', 'Even geduld aub')
  .set('be', 'Even geduld aub')
  .set('fr-be', "S'il vous plaît, attendez");

interface Props {
  language?: string;
}

const ContentLoader = ({ language }: Props) => {
  const host = resolveHost(window.location.host);
  const currentLang = language ? language : host.slice(-2);
  const caption = captionTranslations.get(currentLang);

  return (
    <div className={styles.wrapper}>
      <main className={styles.content}>
        <div className={styles.animationWrapper}>
          <img
            src={process.env.PUBLIC_URL + '/images/icons/loader/loader.gif'}
            alt="Loader animation"
            className={styles.animation}
          />
        </div>
        <div className={styles.notice}>{caption || 'Please wait'}</div>
      </main>
    </div>
  );
};

export default ContentLoader;
